import React from "react";
import EntityForm from "../../EntityForm/EntityForm";
import { entityToFormValuesMapper } from "../../../Common/utils";
import { RESTRICTION_TYPE, WEEK_DAYS } from "../../../Common/constants";
import { defineMessages, injectIntl } from "react-intl";
import moment from "moment";

const messages = defineMessages({
  mustSetDateRange: {
    id: "app.entityForm.mustSetDateRange",
    description: "Date range must be set",
    defaultMessage: "Date range must be set",
  },
  startAfterEnd: {
    id: "app.travelWindow.startAfterEnd",
    description: "Start date must be before end date",
    defaultMessage: "Start date must be before end date",
  },
  overlappingDates: {
    id: "app.travelWindow.overlappingDates",
    description: "Overlapping travel window dates",
    defaultMessage:
      "The selected dates overlap with an existing travel window ({start} – {end}). Please choose a non-overlapping date range.",
  },
});

function customEntityToFormValuesMapper({ entity, fields, locales, translationConfig }) {
  const formValues = entityToFormValuesMapper({
    entity,
    fields,
    locales,
    translationConfig,
  });

  const existingOpenTravel =
    formValues.restrictions &&
    formValues.restrictions[RESTRICTION_TYPE.OPEN_TRAVEL] &&
    formValues.restrictions[RESTRICTION_TYPE.OPEN_TRAVEL].length > 0;

  if (existingOpenTravel) {
    // Clone profundo para evitar que las mutaciones del formulario afecten
    // directamente a la entidad original en la lista (que comparte la misma referencia)
    formValues.restrictions = {
      ...formValues.restrictions,
      [RESTRICTION_TYPE.OPEN_TRAVEL]: formValues.restrictions[RESTRICTION_TYPE.OPEN_TRAVEL].map(
        item => ({
          ...item,
          weekDays: Array.isArray(item.weekDays) ? [...item.weekDays] : [],
        })
      ),
    };
  } else {
    formValues.restrictions = {
      [RESTRICTION_TYPE.OPEN_TRAVEL]: [
        {
          startDate: null,
          endDate: null,
          weekDays: Object.values(WEEK_DAYS),
        },
      ],
    };
  }

  return {
    ...formValues,
  };
}

class PromotionsTravelWindowForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  componentDidMount() {}

  componentWillUnmount() {}

  getFields(fields) {
    return fields && fields.form;
  }

  handleSubmit = ({ formValues }) => {
    const { id, ...otherFormValues } = formValues;

    const entity = otherFormValues;

    this.props.onSubmitEntity({
      entity,
    });
  };

  customValidate = formValues => {
    const restriction = formValues.restrictions.OPEN_TRAVEL[0];

    // 1. Ambas fechas deben estar presentes
    if (!restriction.startDate || !restriction.endDate) {
      return this.props.intl.formatMessage(messages.mustSetDateRange);
    }

    // 2. La fecha de inicio no puede ser posterior a la de fin
    if (moment(restriction.startDate).isAfter(moment(restriction.endDate))) {
      return this.props.intl.formatMessage(messages.startAfterEnd);
    }

    // 3. Sin solapamiento
    const allEntities = this.props.allEntities || [];
    const currentTempId = this.props.entity && this.props.entity._tempId;

    for (const existingEntity of allEntities) {
      // Excluir la entidad que se está editando actualmente
      if (currentTempId !== undefined && existingEntity._tempId === currentTempId) {
        continue;
      }

      const existing =
        existingEntity.restrictions &&
        existingEntity.restrictions.OPEN_TRAVEL &&
        existingEntity.restrictions.OPEN_TRAVEL[0];

      if (!existing || !existing.startDate || !existing.endDate) {
        continue;
      }

      // Dos rangos [s1,e1] y [s2,e2] se solapan si s1 <= e2 AND s2 <= e1
      const overlaps =
        moment(restriction.startDate).isSameOrBefore(moment(existing.endDate)) &&
        moment(existing.startDate).isSameOrBefore(moment(restriction.endDate));

      if (overlaps) {
        return this.props.intl.formatMessage(messages.overlappingDates, {
          start: existing.startDate,
          end: existing.endDate,
        });
      }
    }

    return "";
  };

  render() {
    const { config } = this.props;
    const { name, validation, fields, renderers, translation, entities } = config;
    const {
      locales,
      entity,
      entityError,
      entityResult,
      loading,
      getListPath,
      nested,
      afterSubmit,
      onCancelEdit,
      entityName,
    } = this.props;
    const { getFields, handleSubmit } = this;
    return (
      <EntityForm
        loading={loading}
        name={name}
        entityName={entityName}
        entity={entity}
        entities={entities}
        validation={validation}
        renderers={renderers}
        fields={getFields(fields)}
        locales={locales}
        translation={translation}
        onSubmit={handleSubmit}
        entityError={entityError}
        customValidate={this.customValidate}
        entityResult={entityResult}
        getListPath={getListPath}
        nested={nested}
        afterSubmit={afterSubmit}
        onCancelEdit={onCancelEdit}
        entityToFormValuesMapper={customEntityToFormValuesMapper}
      />
    );
  }
}

PromotionsTravelWindowForm.propTypes = {};

PromotionsTravelWindowForm.defaultProps = {};

export default injectIntl(PromotionsTravelWindowForm);

